import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 22 22"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M13.19 9.55c1.38 0 2.49-1.12 2.49-2.49s-1.12-2.49-2.49-2.49-2.49 1.12-2.49 2.49c0 .2.03.41.09.64L8.43 9.16c-.46-.42-1.05-.65-1.67-.65-1.38 0-2.49 1.12-2.49 2.49s1.12 2.49 2.49 2.49c.62 0 1.21-.23 1.67-.65l2.36 1.46c-.06.23-.09.44-.09.64 0 1.38 1.12 2.49 2.49 2.49s2.49-1.12 2.49-2.49-1.12-2.5-2.49-2.5c-.66 0-1.27.25-1.74.72l-2.31-1.44c.08-.25.12-.5.12-.74s-.04-.48-.12-.74l2.31-1.44c.47.46 1.09.72 1.74.72Zm-1.12-2.49c0-.62.5-1.12 1.12-1.12s1.12.5 1.12 1.12-.5 1.12-1.12 1.12-1.12-.5-1.12-1.12m-4.2 3.95c0 .62-.5 1.12-1.12 1.12s-1.12-.5-1.12-1.12.5-1.12 1.12-1.12 1.12.5 1.12 1.12m4.2 3.95c0-.62.5-1.12 1.12-1.12s1.12.5 1.12 1.12-.5 1.12-1.12 1.12-1.12-.5-1.12-1.12"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M11 0C4.92 0 0 4.92 0 11s4.92 11 11 11 11-4.92 11-11S17.08 0 11 0m0 20.31c-5.14 0-9.31-4.17-9.31-9.31S5.86 1.69 11 1.69s9.31 4.17 9.31 9.31-4.17 9.31-9.31 9.31"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }